import axios from 'axios';
import authHeader from './auth-header';
import Config from '../config/index';

class HeaderService {


    async updateHeader(headerData) {

        if (headerData === null || headerData === undefined) {
            return new Promise((resolve, reject) => {
                reject('Data is empty');
            });
        } else {
            return await axios.put(Config.apiBasePath + '/theme/header', headerData,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        ...authHeader() // Add your authentication headers here if needed
                    }
                });
        }

    }
    async getHeader() {



        const response = await axios.get(Config.apiBasePath + '/theme/header',
            {
                headers: {
                    'Content-Type': 'application/json',
                    ...authHeader() // Add your authentication headers here if needed
                }
            });
        return response;


    }

}

export default new HeaderService();